import React, { useState } from "react"
import AllEmails from "./AllEmails"
import Compose from "./Compose/Compose"

const EmailsTab = ({ userData }) => {
  const [activeTab, setActiveTab] = useState('allEmail')
  const currentURL = window.location.href
  const parts = currentURL.split('/')
  const userId = parts[parts?.length - 1]

  return (
    <div className="w-full">
      {activeTab === "allEmail" && <AllEmails setTab={setActiveTab} userData={userData} userId={userId}/>}
      {activeTab === "compose" && <Compose setTab={setActiveTab} userData={userData} userId={userId}/>}
    </div>
  )
}

export default EmailsTab